(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6544],{

/***/ 66117:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explore",
      function () {
        return __webpack_require__(37525);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 44559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _care_react_icons__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(25682);
/* harmony import */ var _care_react_icons__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(89728);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(23795);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15861);
/* harmony import */ var _mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61730);
/* harmony import */ var he__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86492);
/* harmony import */ var he__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(he__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91036);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(sanitize_html__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _utils_dateMonthYearFormat__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(42182);
/* harmony import */ var _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(883);
/* harmony import */ var _contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73739);











var classes = {
    carouselContainer: function(theme) {
        return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            height: "520px"
        }, theme.breakpoints.up("sm"), {
            height: "600px"
        });
    },
    header: function(theme) {
        return {
            fontSize: "h1.fontSize",
            textAlign: "center",
            padding: theme.spacing(4, 0, 5, 0)
        };
    },
    carouselWrapper: {
        display: "flex",
        justifyContent: "center"
    },
    cardsWrapper: function(theme) {
        return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            display: "flex",
            overflow: "hidden",
            justifyContent: "center",
            width: "279px",
            "&::MsOverflowStyle": "none",
            "&::webkitScrollbar": {
                display: "none"
            }
        }, theme.breakpoints.up("sm"), {
            width: "100%"
        });
    },
    card: function(theme) {
        return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            width: "100%",
            display: "flex",
            flexDirection: "column"
        }, theme.breakpoints.up("sm"), {
            "&:not(:last-child)": {
                padding: theme.spacing(0, 4, 0, 0)
            }
        });
    },
    leftArrow: function(theme) {
        return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            padding: theme.spacing(10, 2, 0, 0),
            "& :hover": {
                cursor: "pointer"
            }
        }, theme.breakpoints.up("md"), {
            padding: theme.spacing(20, 2, 0, 0)
        });
    },
    rightArrow: function(theme) {
        return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            padding: theme.spacing(10, 0, 0, 2),
            "& :hover": {
                cursor: "pointer"
            }
        }, theme.breakpoints.up("md"), {
            padding: theme.spacing(20, 0, 0, 2)
        });
    },
    articleHeader: function(theme) {
        return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            padding: theme.spacing(2, 0, 1)
        }, theme.breakpoints.up("sm"), {
            padding: theme.spacing(2, 0, 1.5)
        });
    },
    articleDate: {
        fontSize: "1rem",
        color: "care.grey.400"
    },
    articleContentWrapper: {
        display: "flex",
        flexDirection: "column",
        alignItems: "end"
    },
    articleDescription: {
        fontSize: ".875rem"
    },
    imgContainer: function(theme) {
        var _obj;
        return _obj = {
            overflow: "hidden",
            height: "186px",
            width: "279px"
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, theme.breakpoints.only("sm"), {
            height: "135px",
            width: "200px"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, theme.breakpoints.up("lg"), {
            height: "243px",
            width: "365px"
        }), _obj;
    },
    imgResponsive: {
        display: "block",
        maxWidth: "100%",
        height: "auto"
    }
};
var ArticleCarousel = function(param) {
    var articles = param.articles;
    var numberOfArticles = articles.length;
    var isMobile = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    var isMobileOrSmaller = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var targetValue = isMobileOrSmaller ? "" : "_blank";
    var segmentNameSingular = (0,_contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_4__/* .usePageAttributes */ .l)().segmentNameSingular;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), index = ref[0], setIndex = ref[1];
    var amplitudeDataRotateArticle = {
        feature_name: "Rotate Article Carousel"
    };
    var articleAmplitudeData = {
        feature_name: "Clicked Article Carousel"
    };
    var handleLeftArrow = function() {
        if (index === 0) {
            setIndex(numberOfArticles - 1);
        } else {
            setIndex(index - 1);
        }
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_3__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_3__/* .AmplitudeEvent.seoFeatureInteracted */ .Sj.seoFeatureInteracted, amplitudeDataRotateArticle);
    };
    var handleRightArrow = function() {
        if (index === numberOfArticles - 1) {
            setIndex(0);
        } else {
            setIndex(index + 1);
        }
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_3__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_3__/* .AmplitudeEvent.seoFeatureInteracted */ .Sj.seoFeatureInteracted, amplitudeDataRotateArticle);
    };
    var renderArticles = function() {
        var currentCountShown = 0;
        var currentIndex = index;
        var currentArticles = [];
        var maxNumOfArticlesToShow = 5;
        while(currentCountShown < maxNumOfArticlesToShow){
            currentArticles.push(articles[currentIndex]);
            currentIndex += 1;
            currentCountShown += 1;
            if (currentIndex >= numberOfArticles) {
                currentIndex = 0;
            }
        }
        return currentArticles.map(function(param, idx) {
            var title = param.title, createDate = param.createDate, description = param.description, url = param.url, smallImage = param.smallImage, largeImage = param.largeImage;
            var articleDate = createDate !== null ? (0,_utils_dateMonthYearFormat__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                dateTime: createDate,
                useOrdinalDay: true,
                useLongMonth: true,
                useFullDate: true
            }) : "";
            /**
         * @param {string | null} description contains a '<p>' in the beginning of the string
         *  that interfere with the styling layout of the Figma design.
         * @const {string} previewDescription makes a copy of @param {string | null} description without the '<p>'
         */ var previewDescription = description !== null ? description.slice(description.indexOf(">") + 1) : "";
            var imageSourceSmall = (smallImage === null || smallImage === void 0 ? void 0 : smallImage.imageUrl) || "";
            var imageSourceLarge = (largeImage === null || largeImage === void 0 ? void 0 : largeImage.imageUrl) || "";
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                sx: classes.card,
                children: [
                    Boolean(smallImage && largeImage) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        sx: classes.imgContainer,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: url,
                            target: targetValue,
                            onClick: function() {
                                return (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_3__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_3__/* .AmplitudeEvent.seoFeatureInteracted */ .Sj.seoFeatureInteracted, articleAmplitudeData);
                            },
                            "data-testid": "imageLink",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                component: "img",
                                src: isMobile ? imageSourceSmall : imageSourceLarge,
                                width: isMobile ? "279" : "365",
                                height: isMobile ? "186" : "243",
                                alt: title,
                                sx: classes.imgResponsive
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        href: url,
                        target: targetValue,
                        sx: classes.articleHeader,
                        "data-testid": "article-title-link",
                        onClick: function() {
                            return (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_3__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_3__/* .AmplitudeEvent.seoFeatureInteracted */ .Sj.seoFeatureInteracted, articleAmplitudeData);
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            dangerouslySetInnerHTML: {
                                __html: sanitize_html__WEBPACK_IMPORTED_MODULE_11___default()(he__WEBPACK_IMPORTED_MODULE_2___default().decode(title))
                            },
                            variant: "h2",
                            component: "h3",
                            "data-testid": "articleTitle"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                component: "span",
                                sx: classes.articleDate,
                                "data-testid": "article-date",
                                children: [
                                    articleDate,
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                component: "span",
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML: {
                                    __html: sanitize_html__WEBPACK_IMPORTED_MODULE_11___default()(he__WEBPACK_IMPORTED_MODULE_2___default().decode(previewDescription))
                                },
                                sx: classes.articleDescription,
                                "data-testid": "article-description"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: "... "
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    underline: "always",
                                    href: url,
                                    variant: "body2",
                                    target: targetValue,
                                    onClick: function() {
                                        return (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_3__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_3__/* .AmplitudeEvent.seoFeatureInteracted */ .Sj.seoFeatureInteracted, articleAmplitudeData);
                                    },
                                    "data-testid": "readMore",
                                    children: "Read more"
                                })
                            })
                        ]
                    })
                ]
            }, "".concat(url, "-").concat(idx + 1));
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        sx: classes.carouselContainer,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                variant: "h2",
                sx: classes.header,
                children: segmentNameSingular ? "".concat(segmentNameSingular, " Articles") : "Related articles"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                sx: classes.carouselWrapper,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        sx: classes.leftArrow,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_icons__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            size: "20px",
                            "data-testid": "leftArrow",
                            onClick: handleLeftArrow
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        sx: classes.cardsWrapper,
                        children: renderArticles()
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        sx: classes.rightArrow,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_icons__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            size: "20px",
                            "data-testid": "rightArrow",
                            onClick: handleRightArrow
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArticleCarousel);


/***/ }),

/***/ 96301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _generated_globalTypes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79967);
/* harmony import */ var _contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73739);





var ref = next_config__WEBPACK_IMPORTED_MODULE_1___default()(), NEXT_PUBLIC_APP_URL = ref.publicRuntimeConfig.NEXT_PUBLIC_APP_URL;
var PageMeta = function(param) {
    var hrefLangLinks = param.hrefLangLinks, title = param.title, canonicalUrl = param.canonicalUrl, metaDescriptions = param.metaDescriptions, metaKeywords = param.metaKeywords, _paginationPageCount = param.paginationPageCount, paginationPageCount = _paginationPageCount === void 0 ? 1 : _paginationPageCount, _paginationCurrentPage = param.paginationCurrentPage, paginationCurrentPage = _paginationCurrentPage === void 0 ? 1 : _paginationCurrentPage, isCostGuidePage = param.isCostGuidePage, seoSegmentNamePlural = param.seoSegmentNamePlural, isCampsAndActivitiesPage = param.isCampsAndActivitiesPage;
    var ref = (0,_contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_4__/* .usePageAttributes */ .l)(), segmentNamePlural = ref.segmentNamePlural, pageType = ref.pageType, city = ref.city, state = ref.state;
    var logoPath = "".concat(NEXT_PUBLIC_APP_URL, "/img/care-no-tag.jpg");
    var prevLink;
    var nextLink;
    var canonicalPageUrl;
    var newTitle;
    var noindexPage = pageType === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_3__/* .SEOSegmentationPageType.LOCAL */ .a6.LOCAL && paginationCurrentPage > 1 || isCampsAndActivitiesPage && paginationCurrentPage > 1;
    if (paginationCurrentPage > 1) {
        if (pageType === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_3__/* .SEOSegmentationPageType.LOCAL */ .a6.LOCAL) {
            newTitle = "Page ".concat(paginationCurrentPage, " - Top ").concat(segmentNamePlural, " in ").concat(city, ", ").concat(state);
        } else {
            newTitle = "Page ".concat(paginationCurrentPage, " - Top ").concat(seoSegmentNamePlural !== null && seoSegmentNamePlural !== void 0 ? seoSegmentNamePlural : segmentNamePlural);
        }
        canonicalPageUrl = "".concat(canonicalUrl, "-page").concat(paginationCurrentPage);
        if (paginationCurrentPage < paginationPageCount) {
            nextLink = "".concat(canonicalUrl, "-page").concat(paginationCurrentPage + 1);
            prevLink = paginationCurrentPage === 2 ? canonicalUrl : "".concat(canonicalUrl, "-page").concat(paginationCurrentPage - 1);
        } else {
            prevLink = "".concat(canonicalUrl);
        }
    } else if (paginationCurrentPage === 1) {
        newTitle = title;
        canonicalPageUrl = canonicalUrl;
        if (paginationPageCount > 1) {
            nextLink = "".concat(canonicalUrl, "-page2");
        }
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            hrefLangLinks && hrefLangLinks.map(function(param) {
                var languageCode = param.languageCode, countryCode = param.countryCode, url = param.url;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "alternate",
                    href: url,
                    hrefLang: "".concat(languageCode, "-").concat(countryCode)
                }, url);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: newTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                httpEquiv: "X-UA-Compatible",
                content: "IE=edge,chrome=1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: metaDescriptions
            }),
            metaKeywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: metaKeywords
            }),
            noindexPage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex, follow"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalPageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1.0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "verify-v1",
                content: "zz15lR180u9eCqTfur/9l+bMP75AampYtDEm6OnbkWY="
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: newTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: logoPath
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: metaDescriptions
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: "Care.com"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: "image/jpeg",
                property: "og:image:type"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: "1080",
                property: "og:image:width"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: "1080",
                property: "og:image:height"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "/img/care-no-tag.jpg"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "fb:page_id",
                content: "6030284861"
            }),
            isCostGuidePage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "shortcut icon",
                href: "https://www.care.com/img/crcm-favicon.ico"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify({
                        "@context": "http://schema.org",
                        "@type": "Organization",
                        logo: logoPath,
                        name: "Care.com",
                        sameAs: [
                            "https://www.facebook.com/caredotcom/",
                            "https://twitter.com/CareDotCom",
                            "https://www.instagram.com/careorg/",
                            "https://www.linkedin.com/company/care-com", 
                        ],
                        url: "https://www.care.com"
                    })
                }
            }),
            !isCostGuidePage && nextLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "next",
                href: nextLink
            }),
            !isCostGuidePage && prevLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "prev",
                href: prevLink
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageMeta);


/***/ }),

/***/ 8410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _care_navigation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29414);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883);




var ref = next_config__WEBPACK_IMPORTED_MODULE_1___default()(), NEXT_PUBLIC_APP_URL = ref.publicRuntimeConfig.NEXT_PUBLIC_APP_URL;
var SeoGlobalNavbar = function(param) {
    var enrollmentURL = param.enrollmentURL, _internalLinkingMenuContent = param.internalLinkingMenuContent, internalLinkingMenuContent = _internalLinkingMenuContent === void 0 ? undefined : _internalLinkingMenuContent;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_navigation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        baseURL: NEXT_PUBLIC_APP_URL,
        findJobURL: "/app/vhp/vertical-triage?memberType=sitter",
        logAnalyticsEvent: _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .logOrEnqueueEvent */ .sw,
        joinNowURL: enrollmentURL,
        internalLinkingMenu: {
            internalLinkingMenu: true,
            internalLinkingMenuContent: internalLinkingMenuContent
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SeoGlobalNavbar);


/***/ }),

/***/ 19147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useResponsive; }
/* harmony export */ });
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61730);

function useResponsive() {
    var isSmallViewport = (0,_mui_material__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.down("sm");
    }); // Mobile Devices
    var isMediumViewport = (0,_mui_material__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.between("sm", "lg");
    }); // Large Mobile and Tablets
    var isLargeViewport = (0,_mui_material__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.up("lg");
    }); // Small and Large Desktops
    return {
        isSmallViewport: isSmallViewport,
        isMediumViewport: isMediumViewport,
        isLargeViewport: isLargeViewport
    };
}



/***/ }),

/***/ 27706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86886);
/* harmony import */ var _components_ArticleCarousel__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44559);



var Articles = function(param) {
    var seoArticlesList = param.seoArticlesList;
    var ref;
    var articles = (ref = seoArticlesList === null || seoArticlesList === void 0 ? void 0 : seoArticlesList.articles) !== null && ref !== void 0 ? ref : null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        sx: {
            px: {
                xs: 2,
                sm: 4
            },
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        },
        children: articles && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
            container: true,
            maxWidth: "lg",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ArticleCarousel__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    articles: articles
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Articles);


/***/ }),

/***/ 883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sj": function() { return /* binding */ AmplitudeEvent; },
/* harmony export */   "UP": function() { return /* binding */ setPagePropertiesFromData; },
/* harmony export */   "rG": function() { return /* binding */ trackAmplitudeEvent; },
/* harmony export */   "sw": function() { return /* binding */ logOrEnqueueEvent; },
/* harmony export */   "xF": function() { return /* binding */ setDeviceDataFromHeaders; }
/* harmony export */ });
/* unused harmony exports WebPlatform, AMPLITUDE_DATE_FORMAT, AMPLITUDE_TIME_FORMAT, AnalyticsHelper, enqueEvent */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _care_amplitude__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91649);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var universal_cookie__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65885);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64487);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42660);








var WebPlatform;
(function(WebPlatform) {
    WebPlatform["MW"] = "Mobile Web";
    WebPlatform["DT"] = "Desktop Web";
})(WebPlatform || (WebPlatform = {}));
var AmplitudeEvent;
(function(AmplitudeEvent) {
    AmplitudeEvent["applySegmentationFilter"] = "Apply Segmentation Filter";
    AmplitudeEvent["clickOnSegmentationFilter"] = "Click on Segmentation Filter";
    AmplitudeEvent["ctaInteracted"] = "CTA Interacted";
    AmplitudeEvent["providerProfileViewed"] = "Provider Profile Viewed";
    AmplitudeEvent["monetateAssetClicked"] = "Monetate Asset Clicked";
    AmplitudeEvent["seoPageViewed"] = "SEO Page Viewed";
    AmplitudeEvent["testExposure"] = "Test Exposure";
    AmplitudeEvent["jobViewed"] = "Job Viewed";
    AmplitudeEvent["seoFeatureInteracted"] = "SEO Feature Interacted";
    AmplitudeEvent["errorViewed"] = "Error Viewed";
})(AmplitudeEvent || (AmplitudeEvent = {}));
var publicRuntimeConfig = next_config__WEBPACK_IMPORTED_MODULE_0___default()().publicRuntimeConfig;
var AMPLITUDE_DATE_FORMAT = "MMDDYYYY";
var AMPLITUDE_TIME_FORMAT = "hh:mm A";
var initialized = false;
var AnalyticsHelper = /*#__PURE__*/ function() {
    "use strict";
    function AnalyticsHelper() {
        var _this = this;
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, AnalyticsHelper);
        this.amplitudeEventsQueue = [];
        this.setHeaderData = function(data) {
            _this.headerData = data;
        };
        this.setPageProperties = function(properties) {
            _this.pageProperties = properties;
        };
        this.getHeaderData = function() {
            return _this.headerData;
        };
        this.setEventInQueue = function(event) {
            // @ts-ignore FIX: event is of never type
            _this.amplitudeEventsQueue.push(event);
        };
        this.getEventFromQueue = function() {
            return _this.amplitudeEventsQueue.shift();
        };
        this.getCommonData = function() {
            var cookies = new universal_cookie__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z();
            var ref = _this.headerData || {}, deviceOs = ref.device_os, isMobile = ref.is_mobile, mobileBrowser = ref.mobile_browser, mobileBrowserVersion = ref.mobile_browser_version;
            var ref1 = _this.pageProperties || {}, seoPageId = ref1.seo_page_id, screenName = ref1.screen_name, screenTemplate = ref1.screen_template, ServiceIdForMember = ref1.service_id_for_member, slots = ref1.slots;
            var czenVisitorId = cookies.get(_constants__WEBPACK_IMPORTED_MODULE_1__/* .CZEN_VISITOR_COOKIE_KEY */ .iN);
            var czenSessionId = cookies.get(_constants__WEBPACK_IMPORTED_MODULE_1__/* .CZEN_SESSION_COOKIE_KEY */ .Ih);
            var screenResolution = "".concat(window.screen.width, " x ").concat(window.screen.height);
            var viewportResolution = "".concat(window.innerWidth, " x ").concat(window.innerHeight);
            var visitorId = czenVisitorId || "VisitorIdNotFound";
            var CZENSessionId = czenSessionId || "SessionIdNotFound";
            var deviceModel = (deviceOs === null || deviceOs === void 0 ? void 0 : deviceOs.split(" ").length) > 1 ? deviceOs === null || deviceOs === void 0 ? void 0 : deviceOs.split(" ")[0] : deviceOs;
            var webPlatform = isMobile === "true" ? WebPlatform.MW : WebPlatform.DT;
            var commonData = {
                czen_session_id: CZENSessionId,
                device_model: deviceModel,
                environment: publicRuntimeConfig.SENTRY_ENV,
                language: navigator.language,
                os_name: mobileBrowser,
                os_version: mobileBrowserVersion,
                referer: document.referrer,
                rendered_by: "seo-mfe",
                screen_name: screenName,
                screen_resolution: screenResolution,
                screen_template: screenTemplate,
                seo_page_id: seoPageId,
                service_id_for_member: ServiceIdForMember,
                slots: slots,
                userAgent: navigator.userAgent,
                viewport_resolution: viewportResolution,
                visitor_id: visitorId,
                web_platform: webPlatform
            };
            return commonData;
        };
        this.logEvent = function(payload) {
            try {
                if (!initialized) {
                    var careAnalyticsConfig = {
                        analyticsEnabled: publicRuntimeConfig.ANALYTICS_ENABLED === "true",
                        key: publicRuntimeConfig.AMPLITUDE_API_KEY,
                        commonData: _this.getCommonData()
                    };
                    (0,_care_amplitude__WEBPACK_IMPORTED_MODULE_4__/* .init */ .S1)(careAnalyticsConfig);
                    initialized = true;
                    // session id is available with a small delay after amplitude initialization
                    setTimeout(function() {
                        var ref;
                        var amplitudeSessionId = (ref = (0,_care_amplitude__WEBPACK_IMPORTED_MODULE_4__/* .getInstance */ .s8)()) === null || ref === void 0 ? void 0 : ref.getSessionId();
                        if (amplitudeSessionId) {
                            (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .configureScope */ .e)(function(scope) {
                                var user = scope.getUser();
                                scope.setUser((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, user), {
                                    amplitudeSessionId: amplitudeSessionId
                                }));
                            });
                        }
                    });
                }
                var logEventPayload = {
                    name: payload.name,
                    data: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, payload.data)
                };
                (0,_care_amplitude__WEBPACK_IMPORTED_MODULE_4__/* .logEvent */ .Kz)(logEventPayload);
            } catch (e) {
                (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .captureException */ .Tb)(e);
            }
        };
    }
    AnalyticsHelper.init = function init() {
        if (this.analytics === undefined) {
            this.analytics = new AnalyticsHelper();
        }
        return this.analytics;
    };
    return AnalyticsHelper;
}();
var enqueEvent = function(event) {
    var analyticsInstance = AnalyticsHelper.init();
    analyticsInstance.setEventInQueue(event);
    return event;
};
var dequeEvent = function() {
    var analyticsInstance = AnalyticsHelper.init();
    return analyticsInstance.getEventFromQueue();
};
var logOrEnqueueEvent = function(param) {
    var name = param.name, data = param.data;
    if (!name || !data) return null;
    var analyticsInstance = AnalyticsHelper.init();
    if (analyticsInstance.getHeaderData() === undefined) {
        return enqueEvent({
            name: name,
            data: data
        });
    }
    return analyticsInstance === null || analyticsInstance === void 0 ? void 0 : analyticsInstance.logEvent({
        data: data,
        name: name
    });
};
var trackAmplitudeEvent = function() {
    var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    logOrEnqueueEvent({
        name: name,
        data: data
    });
};
var setPagePropertiesFromData = function(properties) {
    var analyticsInstance = AnalyticsHelper.init();
    analyticsInstance === null || analyticsInstance === void 0 ? void 0 : analyticsInstance.setPageProperties(properties);
};
var setDeviceDataFromHeaders = function(data) {
    var analyticsInstance = AnalyticsHelper.init();
    analyticsInstance === null || analyticsInstance === void 0 ? void 0 : analyticsInstance.setHeaderData(data);
    var eventsPresentInQueue = analyticsInstance.amplitudeEventsQueue.length;
    if (eventsPresentInQueue > 0) {
        // eslint-disable-next-line no-plusplus
        for(var i = 0; i < eventsPresentInQueue; i++){
            var ref = dequeEvent(), eventName = ref.name, eventData = ref.data;
            trackAmplitudeEvent(eventName, eventData);
        }
        return eventsPresentInQueue;
    }
    return data;
};


/***/ }),

/***/ 37525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* reexport */ campsAndActivities_LandingPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@care/navigation/dist/components/CoreGlobalFooter/CoreGlobalFooter.js + 8 modules
var CoreGlobalFooter = __webpack_require__(69388);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./src/components/PageMeta.tsx
var PageMeta = __webpack_require__(96301);
// EXTERNAL MODULE: ./src/components/SeoGlobalNavbar.tsx
var SeoGlobalNavbar = __webpack_require__(8410);
// EXTERNAL MODULE: ./src/lib/analyticsHelper.tsx
var analyticsHelper = __webpack_require__(883);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(80822);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Card/Card.js
var Card = __webpack_require__(37088);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
;// CONCATENATED MODULE: ./src/components/pages/campsAndActivities/HeroContent.tsx


var HeroContent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        px: {
            xs: 0,
            sm: 6,
            lg: 9
        },
        pt: {
            xs: 1,
            sm: 2,
            md: 6,
            lg: 8
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "h1",
                    fontSize: {
                        md: "display2.fontSize"
                    },
                    sx: function(theme) {
                        return {
                            lineHeight: {
                                md: theme.typography.display2.lineHeight
                            }
                        };
                    },
                    children: [
                        "Find kids activities and camps—",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "without the headaches"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                py: {
                    xs: 2,
                    sm: 3,
                    lg: 4
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body1",
                    fontSize: {
                        md: "h2.fontSize"
                    },
                    children: "Browse, compare, and book classes, after-school programs, and mores—all in one place."
                })
            })
        ]
    });
};
/* harmony default export */ var campsAndActivities_HeroContent = (HeroContent);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/lodash-es/orderBy.js + 10 modules
var orderBy = __webpack_require__(92580);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Select/Select.js
var Select = __webpack_require__(92817);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/TextField/TextField.js
var TextField = __webpack_require__(53340);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Modal/Modal.js + 5 modules
var Modal = __webpack_require__(387);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityChevron.js
var Icon24UtilityChevron = __webpack_require__(68720);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24InfoLocation.js
var Icon24InfoLocation = __webpack_require__(59242);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilitySearch.js
var Icon24UtilitySearch = __webpack_require__(85594);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityChevronLeft.js
var Icon24UtilityChevronLeft = __webpack_require__(12330);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/FormControl.js + 1 modules
var FormControl = __webpack_require__(94054);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(18972);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputAdornment/InputAdornment.js + 1 modules
var InputAdornment = __webpack_require__(87109);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
// EXTERNAL MODULE: ./src/components/hooks/useResponsive.tsx
var useResponsive = __webpack_require__(19147);
;// CONCATENATED MODULE: ./src/components/pages/campsAndActivities/CampsAndActivitiesSearch.tsx













var ZipCodeRegex = /^\d{0,5}$/;
var capitalizeFirstLetter = function(string) {
    if (!string) return string;
    return string.charAt(0).toUpperCase() + string.slice(1);
};
var prefillZipCode = function(userGeoInfo) {
    var zipCodeRegex = /zip=(\d{5})/;
    var match = zipCodeRegex.exec(userGeoInfo);
    if (match === null || match === void 0 ? void 0 : match[1]) {
        return match[1];
    }
    return "";
};
var CampsAndActivitiesSearch = function(param) {
    var userGeoInfo = param.userGeoInfo, activityCategoryLinkSections = param.activityCategoryLinkSections;
    var router = (0,next_router.useRouter)();
    var ref = (0,useResponsive/* useResponsive */.F)(), isSmallViewport = ref.isSmallViewport, isMediumViewport = ref.isMediumViewport;
    var zipInputRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(""), selectedCategory = ref1[0], setSelectedCategory = ref1[1];
    var ref2 = (0,react.useState)(""), selectedSubCategory = ref2[0], setSelectedSubCategory = ref2[1];
    var ref3 = (0,react.useState)(""), zipCodeValue = ref3[0], setZipCodeValue = ref3[1];
    var ref4 = (0,react.useState)(false), openActivitySearchModal = ref4[0], setOpenActivitySearchModal = ref4[1];
    var ref5 = (0,react.useState)([]), categoryOptions = ref5[0], setCategoryOptions = ref5[1];
    var ref6 = (0,react.useState)([]), subCategoryOptions = ref6[0], setSubCategoryOptions = ref6[1];
    var ref7 = (0,react.useState)({}), subCategoryToCategoryMap = ref7[0], setSubCategoryToCategoryMap = ref7[1];
    var prefilledZipCode = (0,react.useMemo)(function() {
        return prefillZipCode(userGeoInfo);
    }, [
        userGeoInfo
    ]);
    var ref8 = (0,react.useState)({
        zipCode: prefilledZipCode
    }), zip = ref8[0], setZip = ref8[1];
    var handleOpenModal = function() {
        setOpenActivitySearchModal(true);
    };
    var handleCloseModal = function() {
        setOpenActivitySearchModal(false);
    };
    var handleCategoryChange = function(event) {
        var selectedCategoryId = event.target.value;
        var selectedCategoryObj = categoryOptions.find(function(category) {
            return category.id === selectedCategoryId;
        });
        setSelectedCategory(selectedCategoryId);
        var ref;
        setSubCategoryOptions((ref = selectedCategoryObj === null || selectedCategoryObj === void 0 ? void 0 : selectedCategoryObj.subCategories) !== null && ref !== void 0 ? ref : []);
        setSelectedSubCategory("");
    };
    var handleSubCategoryChange = function(event) {
        var selectedSubCategoryVal = event.target.value;
        setSelectedSubCategory(selectedSubCategoryVal);
        var relatedCategory = subCategoryToCategoryMap[selectedSubCategoryVal];
        if (relatedCategory) {
            setSelectedCategory(relatedCategory);
        }
    };
    var handleSearchButton = function() {
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.ctaInteracted */.Sj.ctaInteracted, {
            cta_type: "button",
            cta_text: "Search"
        });
        var url = "/explore/d/activities";
        if (selectedSubCategory) {
            url = selectedSubCategory;
        } else if (selectedCategory) {
            url = "/explore/d/".concat(selectedCategory.replace(/_/g, "-").toLowerCase());
        }
        if (zipCodeValue) {
            url += "?zipCode=".concat(zipCodeValue, "&_qs=1");
        }
        router.push(url, undefined, {
            shallow: false
        });
    };
    var onZipCodeChange = function(e) {
        var zipCodeVal = e.target.value;
        if (!ZipCodeRegex.test(zipCodeVal)) {
            return;
        }
        setZip(function(prevValues) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValues), {
                zipCode: zipCodeVal
            });
        });
    };
    var onFilterOpen = function() {
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoFeatureInteracted */.Sj.seoFeatureInteracted, {
            feature_name: "Filter Viewed"
        });
    };
    (0,react.useEffect)(function() {
        if (activityCategoryLinkSections === null || activityCategoryLinkSections === void 0 ? void 0 : activityCategoryLinkSections.linkSections) {
            var orderedCategories = activityCategoryLinkSections.linkSections.map(function(linkSection) {
                return {
                    id: linkSection.id,
                    title: linkSection.title,
                    subCategories: (0,orderBy/* default */.Z)(linkSection.linkList.map(function(link) {
                        var url = new URL(link.url);
                        return {
                            name: link.content,
                            url: url.pathname
                        };
                    }), [
                        "name"
                    ], [
                        "asc"
                    ])
                };
            });
            var sortedCategories = (0,orderBy/* default */.Z)(orderedCategories, function(category) {
                return category.title.toLowerCase();
            });
            setCategoryOptions(sortedCategories);
            var allSubCategories = (0,orderBy/* default */.Z)(orderedCategories.flatMap(function(category) {
                return category.subCategories;
            }), [
                "name"
            ], [
                "asc"
            ]);
            setSubCategoryOptions(allSubCategories);
            var subCategoryMap = {};
            orderedCategories.forEach(function(category) {
                category.subCategories.forEach(function(subCategory) {
                    subCategoryMap[subCategory.url] = category.id;
                });
            });
            setSubCategoryToCategoryMap(subCategoryMap);
            setSelectedCategory("");
            setSelectedSubCategory("");
        }
    }, [
        activityCategoryLinkSections
    ]);
    (0,react.useEffect)(function() {
        if (zipInputRef.current) {
            zipInputRef.current.setSelectionRange(zipInputRef.current.value.length, zipInputRef.current.value.length);
            zipInputRef.current.focus();
        }
    }, [
        zip
    ]);
    (0,react.useEffect)(function() {
        if (selectedCategory || selectedSubCategory) {
            var ref;
            var ref1;
            (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoFeatureInteracted */.Sj.seoFeatureInteracted, {
                feature_name: "Filter Applied",
                location: zip.zipCode,
                categories: selectedCategory,
                subcategories: (ref1 = (ref = subCategoryOptions.find(function(param) {
                    var url = param.url;
                    return url === selectedSubCategory;
                })) === null || ref === void 0 ? void 0 : ref.name) !== null && ref1 !== void 0 ? ref1 : ""
            });
        }
    }, [
        zip.zipCode,
        selectedCategory,
        selectedSubCategory,
        subCategoryOptions
    ]);
    var CategorySelect = /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
        variant: "standard",
        sx: {
            width: "100%",
            backgroundColor: "background.default"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select/* default */.Z, {
            size: "medium",
            displayEmpty: true,
            value: selectedCategory,
            sx: function(theme) {
                var _obj;
                return _obj = {}, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
                    borderRadius: "30px 0 0 30px",
                    minHeight: "64px"
                }), (0,_define_property/* default */.Z)(_obj, "&:hover", {
                    backgroundColor: "background.default"
                }), _obj;
            },
            IconComponent: Icon24UtilityChevron/* default */.Z,
            inputProps: {
                name: "CategorySelect"
            },
            onOpen: onFilterOpen,
            onChange: handleCategoryChange,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                    value: "",
                    disabled: true,
                    children: "Select category"
                }, "select-category"),
                categoryOptions.map(function(category) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                        value: category.id,
                        children: constants/* ACTIVITY_CATEGORY_TITLES */._f[category.id]
                    }, category.id);
                })
            ]
        })
    });
    var SubCategorySelect = /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
        variant: "standard",
        sx: {
            width: "100%",
            backgroundColor: "background.default"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select/* default */.Z, {
            size: "medium",
            displayEmpty: true,
            sx: function(theme) {
                return (0,_define_property/* default */.Z)({}, theme.breakpoints.up("md"), {
                    borderRadius: "0",
                    borderLeft: "none",
                    minHeight: "64px",
                    "&:hover": {
                        backgroundColor: "background.default"
                    }
                });
            },
            value: selectedSubCategory,
            IconComponent: Icon24UtilityChevron/* default */.Z,
            inputProps: {
                name: "SubCategorySelect"
            },
            onOpen: onFilterOpen,
            onChange: handleSubCategoryChange,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                    value: "",
                    disabled: true,
                    children: "Subcategories"
                }, "sub-categories"),
                subCategoryOptions.map(function(subCategory) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                        value: subCategory.url,
                        children: capitalizeFirstLetter(subCategory.name)
                    }, subCategory.url);
                })
            ]
        })
    });
    var LocationInput = /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
        id: "zipCode",
        name: "zipCode",
        inputRef: zipInputRef,
        placeholder: "ZIP code",
        value: zip.zipCode,
        onChange: onZipCodeChange,
        onBlur: function(event) {
            return setZipCodeValue(event.target.value);
        },
        InputProps: {
            startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                position: "start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24InfoLocation/* default */.Z, {})
            })
        },
        sx: function(theme) {
            var _obj;
            return _obj = {
                width: "100%"
            }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
                "& > div:nth-of-type(1)": {
                    borderRadius: "0 30px 30px 0",
                    borderLeft: "none",
                    minHeight: "64px"
                }
            }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("xs"), {
                "& > div:nth-of-type(1)": {
                    minHeight: "64px"
                }
            }), _obj;
        }
    });
    var SearchActivity = /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
        id: "activitySearch",
        placeholder: "Search for an activity",
        sx: {
            width: "100%",
            "& > div:nth-of-type(1)": {
                minHeight: "64px"
            }
        },
        onClick: handleOpenModal,
        InputProps: {
            startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                position: "start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilitySearch/* default */.Z, {})
            }),
            readOnly: true
        }
    });
    var SearchButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        color: "primary",
        variant: "contained",
        size: "medium",
        sx: {
            height: "40px",
            fontSize: "h2.fontSize",
            fontWeight: "700",
            borderRadius: "24px",
            p: 3,
            mt: {
                xs: 1,
                sm: 0
            },
            width: {
                xs: "100%",
                sm: "170px"
            }
        },
        onClick: handleSearchButton,
        children: "Search"
    });
    var MobileView = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        direction: "column",
        spacing: 2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: true,
                children: SearchActivity
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    container: true,
                    justifyContent: "center",
                    children: SearchButton
                })
            })
        ]
    });
    var DesktopView = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        alignItems: "center",
        spacing: 2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 10,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    alignItems: "center",
                    spacing: 0,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: true,
                            children: CategorySelect
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: true,
                            children: SubCategorySelect
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: true,
                            children: LocationInput
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 2,
                children: SearchButton
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isSmallViewport || isMediumViewport ? MobileView : DesktopView,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                open: openActivitySearchModal,
                hideClose: true,
                "aria-labelledby": "camps-and-activities-search-modal",
                variant: "dynamic",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    direction: "column",
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                sx: function(theme) {
                                    var ref;
                                    return {
                                        color: (ref = theme.palette.care) === null || ref === void 0 ? void 0 : ref.navy[900]
                                    };
                                },
                                onClick: handleCloseModal,
                                size: "small",
                                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityChevronLeft/* default */.Z, {}),
                                variant: "text",
                                children: "Go back"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: true,
                            children: CategorySelect
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: true,
                            children: SubCategorySelect
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: true,
                            children: LocationInput
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                container: true,
                                justifyContent: "center",
                                children: SearchButton
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var campsAndActivities_CampsAndActivitiesSearch = (CampsAndActivitiesSearch);

;// CONCATENATED MODULE: ./src/components/pages/campsAndActivities/HeroSection.tsx






var ref = config_default()(), NEXT_ASSET_URL = ref.publicRuntimeConfig.NEXT_ASSET_URL;
var HeroSection = function(param) {
    var userGeoInfo = param.userGeoInfo, activityCategoryLinkSections = param.activityCategoryLinkSections;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        sx: {
            backgroundImage: {
                xs: "none",
                md: "url(".concat(NEXT_ASSET_URL, "/images/campsAndActivities-hero.jpg?im=)")
            },
            backgroundSize: "cover",
            backgroundPosition: "top"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            px: {
                xs: 3,
                sm: 5,
                lg: 0
            },
            py: {
                xs: 2,
                sm: 2,
                md: 7
            },
            sx: {
                width: "100%",
                maxWidth: "1080px",
                margin: "0 auto"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                careVariant: "subtle",
                sx: {
                    borderRadius: {
                        xs: "0",
                        sm: "0",
                        md: "16px"
                    },
                    boxShadow: {
                        xs: "none",
                        sm: "none",
                        md: "0 0 16px rgba(0, 0, 0, 0.15)"
                    },
                    width: "100%",
                    maxWidth: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(campsAndActivities_HeroContent, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        px: {
                            xs: 0,
                            sm: 6,
                            lg: 9
                        },
                        pb: {
                            xs: 1,
                            sm: 1,
                            md: 6,
                            lg: 7
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(campsAndActivities_CampsAndActivitiesSearch, {
                            userGeoInfo: userGeoInfo !== null && userGeoInfo !== void 0 ? userGeoInfo : "",
                            activityCategoryLinkSections: activityCategoryLinkSections
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var campsAndActivities_HeroSection = (HeroSection);

// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24InfoScience.js
var Icon24InfoScience = __webpack_require__(4275);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24InfoArt.js
var Icon24InfoArt = __webpack_require__(4923);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24InfoSports.js
var Icon24InfoSports = __webpack_require__(32892);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24InfoMusic.js
var Icon24InfoMusic = __webpack_require__(45448);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24InfoCelebrate.js
var Icon24InfoCelebrate = __webpack_require__(22499);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24InfoBooks.js
var Icon24InfoBooks = __webpack_require__(67531);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24InfoMountains.js
var Icon24InfoMountains = __webpack_require__(14937);
;// CONCATENATED MODULE: ./src/components/pages/campsAndActivities/CategoryTiles.tsx




var categoryInfo = [
    {
        displayName: "STEM",
        url: "/explore/d/stem",
        categoryIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24InfoScience/* default */.Z, {
            size: 48
        })
    },
    {
        displayName: "Art",
        url: "/explore/d/art",
        categoryIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24InfoArt/* default */.Z, {
            size: 48
        })
    },
    {
        displayName: "Sports",
        url: "/explore/d/sports",
        categoryIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24InfoSports/* default */.Z, {
            size: 48
        })
    },
    {
        displayName: "Music",
        url: "/explore/d/music",
        categoryIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24InfoMusic/* default */.Z, {
            size: 48
        })
    },
    {
        displayName: "Dance",
        url: "/explore/d/dance",
        categoryIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24InfoCelebrate/* default */.Z, {
            size: 48
        })
    },
    {
        displayName: "Academics",
        url: "/explore/d/academic",
        categoryIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24InfoBooks/* default */.Z, {
            size: 48
        })
    },
    {
        displayName: "Adventure",
        url: "/explore/d/outdoor-and-adventure",
        categoryIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24InfoMountains/* default */.Z, {
            size: 48
        })
    }, 
];
function CategoryTiles() {
    var onCategoryClick = function(category) {
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoFeatureInteracted */.Sj.seoFeatureInteracted, {
            category: category,
            feature_name: "Category tile"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            pb: {
                xs: 5,
                md: 8
            },
            px: {
                xs: 3,
                lg: 10
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                pt: {
                    xs: 1,
                    sm: 2,
                    md: 5
                },
                pb: {
                    xs: 1
                },
                px: {
                    xs: 1,
                    sm: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h2",
                    sx: {
                        textAlign: {
                            xs: "left",
                            sm: "center"
                        },
                        fontSize: {
                            xs: "body1.fontSize",
                            sm: "h2.fontSize"
                        }
                    },
                    children: "Popular categories"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    justifyContent: {
                        xs: "flex-start",
                        sm: "center"
                    },
                    flexDirection: {
                        xs: "row",
                        sm: "colmn"
                    },
                    flexWrap: {
                        xs: "no-wrap",
                        sm: "wrap"
                    },
                    overflowX: {
                        xs: "scroll",
                        sm: "auto"
                    },
                    margin: "0 auto",
                    "&::-webkit-scrollbar": {
                        display: "none"
                    },
                    "-ms-overflow-style": "none",
                    "scrollbar-width": "none"
                },
                children: categoryInfo.map(function(option, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: option.url,
                        sx: {
                            color: "text.primary",
                            textDecoration: "none",
                            fontWeight: "400",
                            "&:hover": {
                                textDecoration: "none"
                            }
                        },
                        onClick: function() {
                            return onCategoryClick(option.displayName);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                            tabIndex: index,
                            sx: function(theme) {
                                return {
                                    display: "flex",
                                    flexDirection: {
                                        xs: "column"
                                    },
                                    alignItems: "center",
                                    justifyContent: "center",
                                    height: "104px",
                                    borderRadius: 4,
                                    boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.15)",
                                    cursor: "pointer",
                                    paddingY: 2,
                                    mr: {
                                        xs: 1,
                                        sm: 2,
                                        md: 1,
                                        lg: 2
                                    },
                                    mb: {
                                        xs: 2,
                                        sm: 1.5
                                    },
                                    mt: {
                                        xs: 1,
                                        sm: 2
                                    },
                                    ml: {
                                        xs: 0.5,
                                        sm: 0
                                    },
                                    "&:hover": {
                                        boxShadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.15)"
                                    },
                                    width: {
                                        xs: "104px",
                                        sm: "125px",
                                        md: "120px",
                                        lg: "140px"
                                    },
                                    svg: {
                                        color: theme.palette.default.main,
                                        height: "48px",
                                        path: {
                                            color: theme.palette.default.main,
                                            fill: theme.palette.default.main
                                        }
                                    }
                                };
                            },
                            "data-testid": option.displayName,
                            children: [
                                option.categoryIcon,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        color: "secondary",
                                        textAlign: "center",
                                        children: option.displayName
                                    })
                                })
                            ]
                        })
                    }, option.url);
                })
            })
        ]
    });
}
/* harmony default export */ var campsAndActivities_CategoryTiles = (CategoryTiles);

// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js + 1 modules
var List = __webpack_require__(78462);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItem/ListItem.js + 4 modules
var ListItem = __webpack_require__(70891);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityRefresh.js
var Icon24UtilityRefresh = __webpack_require__(50216);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24InfoResources.js
var Icon24InfoResources = __webpack_require__(60712);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24InfoStar.js
var Icon24InfoStar = __webpack_require__(19067);
;// CONCATENATED MODULE: ./src/components/pages/campsAndActivities/ValueProp.tsx






var ValueProp_ref = config_default()(), ValueProp_NEXT_ASSET_URL = ValueProp_ref.publicRuntimeConfig.NEXT_ASSET_URL;
var VALUE_PROP_CONTENT = [
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilitySearch/* default */.Z, {}),
        headline: "Effortless booking",
        subHeadline: "Compare, choose, and book the activities you love—all with just a few clicks."
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityRefresh/* default */.Z, {
            size: 48
        }),
        headline: "Personalized to you",
        subHeadline: "Advanced search options make it easy to match programs with you and your child’s preferences."
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24InfoResources/* default */.Z, {
            size: 48
        }),
        headline: "Reviews you can trust",
        subHeadline: "With ratings and reviews from parents like you, you can feel confident in your choice."
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24InfoStar/* default */.Z, {
            size: 48
        }),
        headline: "All needs, one place",
        subHeadline: "From nannies and sitters to camps and activities, your entire childcare plan can stay here."
    }, 
];
function ValueProp() {
    var isSmallViewport = (0,useResponsive/* useResponsive */.F)().isSmallViewport;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            pt: {
                xs: 0,
                sm: 12,
                md: 8
            },
            pb: {
                xs: 3,
                sm: 12,
                md: 8
            },
            px: {
                xs: 3,
                sm: 5,
                md: 4
            },
            display: "flex",
            justifyContent: "center",
            maxWidth: {
                xs: "500px",
                sm: "none"
            },
            boxSizing: "content-box",
            mx: "auto"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            sx: {
                flexDirection: {
                    xs: "column-reverse",
                    sm: "row",
                    md: "row"
                },
                gap: {
                    xs: 4,
                    sm: 11,
                    md: 11
                },
                height: {
                    sm: "357px",
                    md: "408px"
                },
                background: "background.default",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                maxWidth: "1062px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        width: {
                            xs: "100%",
                            sm: "377px",
                            md: "554px"
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "h1",
                            color: "textPrimary",
                            sx: function(theme) {
                                var _obj;
                                return _obj = {
                                    mb: 2,
                                    lineHeight: {
                                        xs: "42px",
                                        lg: "34px"
                                    },
                                    minWidth: "237px",
                                    maxWidth: "300px",
                                    "& strong": {
                                        boxDecorationBreak: "clone",
                                        backgroundColor: "background.blue",
                                        padding: {
                                            xs: "2px",
                                            sm: "4px",
                                            md: "4px"
                                        },
                                        borderRadius: "8px",
                                        lineHeight: {
                                            sm: "42px",
                                            md: "60px"
                                        }
                                    },
                                    fontSize: "h1.fontSize"
                                }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up(470), {
                                    maxWidth: "initial"
                                }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up(834), {
                                    minWidth: "420px"
                                }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
                                    minWidth: "initial",
                                    fontSize: "display3.fontSize"
                                }), _obj;
                            },
                            children: [
                                "Easy to enjoy, ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "easier to book"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                            sx: {
                                width: {
                                    sm: "450px",
                                    md: "100%"
                                },
                                mb: {
                                    xs: "27px",
                                    sm: "32px"
                                },
                                "> .MuiListItem-root": {
                                    mb: "32px"
                                },
                                "li:first-child p:first-child": {
                                    pr: {
                                        xs: "6px"
                                    }
                                },
                                "& li": {
                                    py: "0"
                                }
                            },
                            children: VALUE_PROP_CONTENT.map(function(item) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.ZP, {
                                    disableGutters: true,
                                    alignItems: "flex-start",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            sx: {
                                                flexShrink: 0,
                                                mr: {
                                                    xs: 2,
                                                    sm: 4
                                                },
                                                width: {
                                                    xs: "40px",
                                                    md: "48px"
                                                },
                                                height: {
                                                    xs: "40px",
                                                    md: "48px"
                                                },
                                                "& svg": {
                                                    width: "100%",
                                                    height: "100%"
                                                }
                                            },
                                            children: item.icon
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: !isSmallViewport ? "h2" : "h3",
                                                    mb: 1,
                                                    children: item.headline
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "body2",
                                                    children: item.subHeadline
                                                })
                                            ]
                                        })
                                    ]
                                }, item.headline);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        borderRadius: "16px",
                        border: "1px solid #fff",
                        overflow: "hidden",
                        width: {
                            xs: "100%"
                        },
                        maxWidth: {
                            sm: "327px",
                            md: "519px"
                        },
                        flexBasis: {
                            sm: "40%"
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            height: {
                                xs: "277px",
                                sm: "401px",
                                md: "490px"
                            },
                            width: {
                                sm: "100%"
                            },
                            maxWidth: "100%",
                            backgroundImage: {
                                xs: "url(".concat(ValueProp_NEXT_ASSET_URL, "/images/value-prop-mw.jpg?im=)"),
                                sm: "url(".concat(ValueProp_NEXT_ASSET_URL, "/images/value-prop-dt.jpg?im=)")
                            },
                            backgroundPosition: {
                                xs: "center",
                                sm: "30%",
                                md: "40%",
                                lg: "center"
                            },
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "cover",
                            backgroundColor: {
                                sm: "background.default",
                                md: "#FAF7F7"
                            }
                        },
                        "data-testid": "value-prop-image"
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var campsAndActivities_ValueProp = (ValueProp);

// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityCheckmarkLarge.js
var Icon24UtilityCheckmarkLarge = __webpack_require__(54362);
;// CONCATENATED MODULE: ./src/components/pages/campsAndActivities/Seasonality.tsx






var Seasonality_ref = config_default()(), Seasonality_NEXT_ASSET_URL = Seasonality_ref.publicRuntimeConfig.NEXT_ASSET_URL;
var SEASONALITY_CONTENT = [
    {
        headline: "For when school's out for summer",
        subHeadline: "Discover full-day sports camps or week-long programs over the dog days of summer."
    },
    {
        headline: "For when school takes a break",
        subHeadline: "Keep kids engaged over spring or winter break with short-term art classes, STEM camps, and more."
    },
    {
        headline: "For when school is back in session",
        subHeadline: "Help your kid get back into the swing of things with after-school enrichment programs."
    }, 
];
function Seasonality() {
    var isSmallViewport = (0,useResponsive/* useResponsive */.F)().isSmallViewport;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        item: true,
        sx: {
            width: "100%",
            margin: "auto",
            marginTop: {
                xs: 0,
                md: 8
            },
            marginBottom: {
                xs: 1,
                md: 8
            },
            borderRadius: {
                xs: "0 0 64px 64px",
                sm: "0 0 120px 120px"
            },
            backgroundColor: "#FAF7F7",
            flexDirection: {
                xs: "column",
                md: "row"
            },
            flexWrap: "nowrap"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                container: true,
                item: true,
                sx: {
                    height: {
                        xs: "285px",
                        sm: "380px",
                        md: "650px"
                    },
                    width: {
                        xs: "100%",
                        md: "45%"
                    },
                    backgroundImage: {
                        xs: "url(".concat(Seasonality_NEXT_ASSET_URL, "/images/seasonality-mw.jpg?im=)"),
                        md: "url(".concat(Seasonality_NEXT_ASSET_URL, "/images/seasonality-dt.jpg?im=)")
                    },
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    borderRadius: {
                        xs: "none",
                        md: "0 0 0 120px"
                    },
                    overflow: "hidden",
                    pr: {
                        xs: 0,
                        xl: "189px"
                    },
                    pl: {
                        xl: 0
                    },
                    pb: "37px"
                },
                direction: "row"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    justifyContent: "center",
                    px: 3,
                    mt: {
                        xs: 3,
                        sm: 4,
                        md: 6
                    },
                    mb: {
                        xs: 6,
                        sm: 8,
                        md: 5
                    },
                    maxWidth: {
                        xs: "500px",
                        sm: "none"
                    },
                    boxSizing: {
                        xs: "content-box",
                        sm: "border-box"
                    },
                    mx: "auto"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    item: true,
                    sx: {
                        width: "auto",
                        "> *": {
                            maxWidth: {
                                xs: "none",
                                sm: "560px",
                                md: "500px"
                            }
                        }
                    },
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "h2",
                            sx: function(theme) {
                                var ref;
                                var _obj;
                                return _obj = {
                                    mb: {
                                        sm: 1,
                                        md: 4
                                    },
                                    mt: {
                                        xs: 2,
                                        sm: 2,
                                        md: 8
                                    },
                                    lineHeight: {
                                        xs: "42px",
                                        lg: "34px"
                                    },
                                    minWidth: "237px",
                                    maxWidth: "300px",
                                    "& strong": {
                                        boxDecorationBreak: "clone",
                                        backgroundColor: (ref = theme.palette.care) === null || ref === void 0 ? void 0 : ref.blue[100],
                                        padding: {
                                            xs: "2px",
                                            sm: "4px",
                                            md: "4px"
                                        },
                                        borderRadius: "8px",
                                        lineHeight: {
                                            sm: "42px",
                                            md: "60px"
                                        }
                                    },
                                    fontSize: "h1.fontSize"
                                }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up(470), {
                                    maxWidth: "initial"
                                }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up(834), {
                                    minWidth: "420px"
                                }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
                                    minWidth: "initial",
                                    fontSize: "display3.fontSize"
                                }), _obj;
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "Engaging activities"
                                }),
                                " for",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "every season"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h3",
                            sx: {
                                fontSize: {
                                    xs: "h3.fontSize",
                                    sm: "h2.fontSize"
                                },
                                pt: {
                                    xs: 2,
                                    md: 3
                                },
                                fontWeight: 400,
                                lineHeight: "24px",
                                pr: {
                                    md: "50px"
                                }
                            },
                            children: "Whether you're looking at summer vacation, spring break, or those after-school care gaps—we have you covered all year round."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                            sx: {
                                mt: {
                                    xs: 3,
                                    md: 4
                                }
                            },
                            children: SEASONALITY_CONTENT.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.ZP, {
                                    disableGutters: true,
                                    alignItems: "flex-start",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            sx: {
                                                flexShrink: 0,
                                                marginRight: 2
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityCheckmarkLarge/* default */.Z, {
                                                width: 22,
                                                height: 22
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: !isSmallViewport ? "h2" : "h3",
                                                    mb: 1,
                                                    children: item.headline
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "body2",
                                                    mb: 1,
                                                    children: item.subHeadline
                                                })
                                            ]
                                        })
                                    ]
                                }, "point-".concat(index + 1));
                            })
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var campsAndActivities_Seasonality = (Seasonality);

// EXTERNAL MODULE: ./src/components/pages/campsAndActivities/Articles.tsx
var Articles = __webpack_require__(27706);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(65582);
// EXTERNAL MODULE: ./node_modules/@mui/material/Accordion/Accordion.js + 3 modules
var Accordion = __webpack_require__(82280);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionDetails/AccordionDetails.js + 1 modules
var AccordionDetails = __webpack_require__(22797);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionSummary/AccordionSummary.js + 1 modules
var AccordionSummary = __webpack_require__(38895);
// EXTERNAL MODULE: ./node_modules/lodash-es/upperFirst.js + 7 modules
var upperFirst = __webpack_require__(58939);
// EXTERNAL MODULE: ./node_modules/he/he.js
var he = __webpack_require__(86492);
var he_default = /*#__PURE__*/__webpack_require__.n(he);
// EXTERNAL MODULE: ./node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(91036);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
;// CONCATENATED MODULE: ./src/components/pages/campsAndActivities/InternalLinks.tsx









var InternalLinks = function(param) {
    var activityCategoryLinkSections = param.activityCategoryLinkSections;
    var isSmallViewport = (0,useResponsive/* useResponsive */.F)().isSmallViewport;
    var links = function(linkList) {
        var sortedLinks = (0,orderBy/* default */.Z)(linkList, [
            "label"
        ], [
            "asc"
        ]);
        return sortedLinks.map(function(link) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                variant: isSmallViewport ? "link2" : "link1",
                sx: {
                    cursor: "pointer",
                    color: "text.primary",
                    lineHeight: "40px",
                    textDecoration: "underline"
                },
                href: link.address,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML: {
                        __html: sanitize_html_default()(he_default().decode((0,upperFirst/* default */.Z)(link.label)))
                    }
                })
            }, link.label);
        });
    };
    var sortedSections = (0,react.useMemo)(function() {
        var transformLinksData = function() {
            if (!activityCategoryLinkSections) return [];
            return activityCategoryLinkSections.linkSections.map(function(section) {
                return {
                    label: section.id,
                    items: section.linkList.map(function(link) {
                        return {
                            address: link.url,
                            label: link.content
                        };
                    })
                };
            });
        };
        return (0,orderBy/* default */.Z)(transformLinksData(), [
            "label"
        ], [
            "asc"
        ]);
    }, [
        activityCategoryLinkSections
    ]);
    if (isSmallViewport) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            sx: function() {
                return {
                    backgroundColor: "#FAF7F7",
                    px: 3,
                    py: 4,
                    mt: 4
                };
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                maxWidth: "md",
                item: true,
                xs: 12,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h1",
                        pb: 2,
                        children: "Explore all categories"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                        defaultExpanded: true,
                        elevation: 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                            sx: {
                                m: 0,
                                p: 0
                            },
                            children: sortedSections.map(function(tabSection) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
                                    elevation: 0,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                                            sx: {
                                                width: "100%",
                                                padding: 0,
                                                "& .MuiIconButton-root": {
                                                    marginRight: "-7px"
                                                },
                                                minHeight: "48px"
                                            },
                                            expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityChevron/* default */.Z, {
                                                color: "#172C42"
                                            }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "h3",
                                                children: constants/* ACTIVITY_CATEGORY_TITLES */._f[tabSection.label]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                                            sx: {
                                                m: 0,
                                                p: 0
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                sx: {
                                                    display: {
                                                        sm: "flex"
                                                    }
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    sx: {
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        width: "100%"
                                                    },
                                                    children: links(tabSection.items)
                                                })
                                            })
                                        })
                                    ]
                                }, tabSection.label);
                            })
                        })
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            backgroundColor: "#FAF7F7",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: "lg",
            sx: {
                pt: 2,
                pb: 6
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                children: sortedSections.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h2",
                            fontSize: "display3.fontSize",
                            textAlign: "center",
                            pt: 5,
                            pb: 8,
                            px: 0,
                            children: "Explore all categories"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                minHeight: {
                                    sm: "200px"
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                container: true,
                                spacing: 4,
                                children: sortedSections.map(function(linkSection) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        sm: 3,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                            sx: {
                                                cursor: "pointer",
                                                lineHeight: "30px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "h2",
                                                    sx: {
                                                        pb: 2
                                                    },
                                                    children: constants/* ACTIVITY_CATEGORY_TITLES */._f[linkSection.label]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    sx: {
                                                        display: {
                                                            sm: "flex"
                                                        }
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                        sx: {
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            width: "100%"
                                                        },
                                                        children: links(linkSection.items)
                                                    })
                                                })
                                            ]
                                        })
                                    }, linkSection.label);
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var campsAndActivities_InternalLinks = (InternalLinks);

;// CONCATENATED MODULE: ./src/components/pages/campsAndActivities/LandingPage.tsx













var LandingPage = function(param) {
    var deviceChar = param.deviceChar, userGeoInfo = param.userGeoInfo, activityCategoryLinkSections = param.activityCategoryLinkSections, seoArticlesListData = param.seoArticlesListData;
    var metaTitle = "Explore: kids activities, camps and classes - Care.com";
    var metaDescription = "Book the best kids activities, camps and classes from local providers";
    var canonicalUrl = "https://www.care.com/explore";
    (0,react.useEffect)(function() {
        var pageProperties = {
            seo_page_id: 1539,
            screen_name: "Explore landing page",
            screen_template: "Explore landing page"
        };
        if (deviceChar && Object.keys(deviceChar).length > 0) {
            (0,analyticsHelper/* setPagePropertiesFromData */.UP)(pageProperties);
            (0,analyticsHelper/* setDeviceDataFromHeaders */.xF)(deviceChar);
        }
    }, [
        deviceChar
    ]);
    (0,react.useEffect)(function() {
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoPageViewed */.Sj.seoPageViewed, {
            seo_page_type: "Explore landing page",
            page_template: "Explore landing page",
            seo_page_title: "Find kids activities and camps— without the headaches"
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        container: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            item: true,
            xs: 12,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default */.Z, {
                    title: metaTitle,
                    metaDescriptions: metaDescription,
                    canonicalUrl: canonicalUrl
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoGlobalNavbar/* default */.Z, {
                    enrollmentURL: "/app/vhp/get-started"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(campsAndActivities_HeroSection, {
                    userGeoInfo: userGeoInfo,
                    activityCategoryLinkSections: activityCategoryLinkSections
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(campsAndActivities_CategoryTiles, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(campsAndActivities_ValueProp, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(campsAndActivities_Seasonality, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Articles/* default */.Z, {
                    seoArticlesList: seoArticlesListData
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(campsAndActivities_InternalLinks, {
                    activityCategoryLinkSections: activityCategoryLinkSections
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CoreGlobalFooter/* default */.Z, {})
            ]
        })
    });
};
/* harmony default export */ var campsAndActivities_LandingPage = (LandingPage);

;// CONCATENATED MODULE: ./src/pages/explore.tsx
var __N_SSP = true;



/***/ }),

/***/ 42182:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/*
 * date conversion to one of the following example formats:
 * Apr 2023
 * April 2023
 * Apr 25, 2023
 * April 25, 2023
 * Apr 25th, 2023
 * April 25th, 2023
 */ // Add postfix like 3rd, 4th, 22nd to the date
var getOrdinalNum = function(n) {
    return n + (n > 0 ? [
        "th",
        "st",
        "nd",
        "rd"
    ][n > 3 && n < 21 || n % 10 > 3 ? 0 : n % 10] : "");
};
var dateMonthYearFormat = function(param) {
    var dateTime = param.dateTime, _useLongMonth = param.useLongMonth, useLongMonth = _useLongMonth === void 0 ? false : _useLongMonth, _useOrdinalDay = param.useOrdinalDay, useOrdinalDay = _useOrdinalDay === void 0 ? false : _useOrdinalDay, _useFullDate = param.useFullDate, useFullDate = _useFullDate === void 0 ? false : _useFullDate;
    var date = new Date(dateTime);
    var dayOftheMonth = useOrdinalDay ? "".concat(getOrdinalNum(date.getUTCDate())) : date.getUTCDate();
    var month = useLongMonth ? date.toLocaleString("en-US", {
        month: "long"
    }) : date.toLocaleString("en-US", {
        month: "short"
    });
    var year = date.getUTCFullYear();
    return useFullDate ? "".concat(month, " ").concat(dayOftheMonth, ", ").concat(year) : "".concat(month, " ").concat(year);
};
/* harmony default export */ __webpack_exports__["Z"] = (dateMonthYearFormat);


/***/ }),

/***/ 75347:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 31777:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 34017:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 59905:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2453,898,9417,1207,1767,1036,1903,9635,6492,8576,4858,4875,6610,1531,9774,2888,179], function() { return __webpack_exec__(66117); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);